<div *ngIf="!isLoggedIn" style="font-size:20px; margin: 50px 0 0 50px; height: 600px;">
  Please log in to see this content. If your account has expired, please contact
  <a href="mailto:admin@flightbi.com">admin@flightbi.com</a> for a subscription.
</div>

<div *ngIf="isLoggedIn" style="min-width:350px;">
  <!-- Toolbar -->
  <p-toolbar [style]="{'justify-content':'initial'}">
    <div>
      <p-autoComplete field="code" (onSelect)="selectAirport($event)" (onUnselect)="unselectAirport($event)"
                      (onFocus)="$event.target.select()" #airportInput (onKeyUp)="airportKeyUp($event)"
                      [multiple]="true" [(ngModel)]="selectedObjects" [inputStyle]="{width:'295px'}"
                      [suggestions]="filteredAirports" (completeMethod)="filterAirport($event)"
                      [dropdown]="true" [forceSelection]="true" [autoHighlight]="true"
                      placeholder="Airport" class="p-mr-2">
        <ng-template let-obj pTemplate="item">
          <div>{{obj.display}}</div>
        </ng-template>
      </p-autoComplete>
      <button pButton *ngIf="selectedAirports!=''" icon="pi pi-times"  class="p-button-text p-button-plain"
                (click)="clearAirports()" style="position:relative;left:-75px;top:-2px;z-index:999;padding:5px;"></button>
    </div>
    <p-dropdown *ngIf="terminals.length>0 && tabIndex!=5" [options]="terminals" optionLabel="CHECKPOINT"
                (onChange)="selectTerminal($event)" class="p-mr-1" [style]="{width:'275px'}"
                placeholder="Terminal/Checkpoint" [showClear]="true"></p-dropdown>
      <div *ngIf="useDates">
        <p-calendar [(ngModel)]="startDate" [showButtonBar]="true"
                    [yearNavigator]="true" yearRange="2014:2030" [monthNavigator]="true" [minDate]="minDate"
                    dateFormat="D M d, yy" [style]="{'width':'165px'}" [readonlyInput]="true"
                    (onSelect)="selectDate($event)"></p-calendar>
        <span>&nbsp;-&nbsp;</span>
        <p-calendar [(ngModel)]="endDate"  [showButtonBar]="true" class="p-mr-2"
                    [yearNavigator]="true" yearRange="2014:2030" [monthNavigator]="true" [minDate]="minDate"
                    dateFormat="D M d, yy" [style]="{'width':'165px'}" [readonlyInput]="true"
                    (onSelect)="selectDate($event)"></p-calendar>
      </div>
      <div *ngIf="useDates">
        <button pButton type="button" icon="pi pi-angle-left" class="p-button-outlined p-mr-2"
                pTooltip="Shift backward {{interval}} days" tooltipPosition="bottom"
                (click)="prevPeriod()"></button>
        <button pButton type="button" icon="pi pi-angle-right" class="p-button-outlined p-mr-2"
                pTooltip="Shift forward {{interval}} days" tooltipPosition="bottom"
                (click)="nextPeriod()"></button>
      </div>
      <p-button icon="pi pi-refresh" (onClick)="refreshChart()" class="p-ml-auto p-mr-2"
                pTooltip="Refresh the chart" tooltipPosition="bottom"></p-button>
      <p-button icon="pi pi-table" (onClick)="showData()"
                pTooltip="Show chart data" tooltipPosition="bottom"></p-button>

  </p-toolbar>

  <!-- Tabs -->
  <p-tabView [activeIndex]="tabIndex" (onChange)="tabChange($event)">
    <p-tabPanel header="Year Over Year">
      <div class="card p-d-flex p-jc-center">
        <div>
          <p-dropdown [options]="lines" optionLabel="name" [(ngModel)]="selectedLine"></p-dropdown>
          <div class="card" style="margin-bottom:15px;margin-top:-33px;">
            <app-yoy *ngIf="selectedLine.code=='1'"
                            [latestActual]="latestActual"
                            [params]="params" [lineCode]="selectedLine.code"
                            [startDate]="startDate" [endDate]="endDate"
                            (dataEvent)="updateYOYData($event)">
            </app-yoy>
            <app-yoy *ngIf="selectedLine.code=='7'"
                            [latestActual]="latestActual"
                            [params]="params" [lineCode]="selectedLine.code"
                            [startDate]="startDate" [endDate]="endDate"
                            (dataEvent)="updateYOYData($event)">
            </app-yoy>
            <app-yoy *ngIf="selectedLine.code=='30'"
                            [latestActual]="latestActual"
                            [params]="params" [lineCode]="selectedLine.code"
                            [startDate]="startDate" [endDate]="endDate"
                            (dataEvent)="updateYOYData($event)">
            </app-yoy>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Time Series">
      <ng-template pTemplate="content">
        <div class="card p-d-flex p-jc-center">
          <div>
            <div class="p-d-flex p-jc-end">
              <label class="switch-label">Zoom/Pan</label>
              <p-inputSwitch [ngModel]="chartOptions.plugins.zoom.zoom.enabled"
                             (onChange)="changeZoomPan()" ></p-inputSwitch>
            </div>
            <p-chart type="line" [data]="tsData" [options]="chartOptions" #chartTS
                     [height]="chartHeight" [width]="chartWidth"></p-chart>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Hourly Curves">
      <ng-template pTemplate="content">
        <div class="card p-d-flex p-jc-center">
          <div>
            <div class="p-d-flex">
                <label class="switch-label">Stacked</label>
                <p-inputSwitch [(ngModel)]="stackedHourlyChart"
                               (onChange)="changeHourlyChart($event)"></p-inputSwitch>
                <label class="switch-label p-ml-auto">Zoom/Pan</label>
                <p-inputSwitch [ngModel]="chartOptions.plugins.zoom.zoom.enabled"
                               (onChange)="changeZoomPan()" ></p-inputSwitch>
            </div>
            <div class="card">
              <p-chart type="line" [data]="hourlyData" [options]="chartOptions" #chartHourly
                       [height]="chartHeight" [width]="chartWidth"></p-chart>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Hourly Heatmap">
      <ng-template pTemplate="content">
        <!-- Title -->
        <Label class="title">Traffic by Date and Hour at {{location}}</Label>
        <div class="card p-d-flex p-jc-center">
        <div class="card" style="width:95%;margin:10px;">
          <app-d3matrix [params]="params" [token]="token"></app-d3matrix>
        </div>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Distribution">
      <ng-template pTemplate="content">
          <p-dropdown [options]="charts" optionLabel="name" [(ngModel)]="selectedChart"
                      class="float-right"></p-dropdown>
          <div class="card">
            <app-d3pie *ngIf="selectedChart.code=='donut'" [data]="distData"
                       [params]="params" [token]="token"
                       (dataEvent)="updateDistData($event)"></app-d3pie>
            <app-d3circles *ngIf="selectedChart.code=='circle'" [data]="distData"
                           [params]="params" [token]="token"
                           (dataEvent)="updateDistData($event)"></app-d3circles>
            <app-d3bar *ngIf="selectedChart.code=='bar'" [data]="distData"
                       [params]="params" [token]="token"
                       (dataEvent)="updateDistData($event)"></app-d3bar>
            <app-map *ngIf="selectedChart.code=='map'"
                     [selectedAirports]="selectedAirports" [params]="params"></app-map>
          </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Benchmark">
      <ng-template pTemplate="content">
        <div class="card p-d-flex p-jc-center">
          <app-comparison #benchmark [airports]="selectedAirports" [latestActual]="latestActual"
                          [params]="params" [lineCode]="bk" [chartOptions]="chartOptions" [interval]="benchmarkInterval"
                          (dataEvent)="updateBenchmarkData($event)">
          </app-comparison>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel *ngIf="selectedAirports.indexOf(',')>0" header="Comparison">
      <ng-template pTemplate="content">
        <div class="card p-d-flex p-jc-center">
          <div>
            <p-dropdown [options]="lines" optionLabel="name" [(ngModel)]="selectedLine"></p-dropdown>
            <div class="card" style="margin-bottom:15px;margin-top:-33px;">
                <app-comparison *ngIf="selectedLine.code=='1'" #comp1
                                [airports]="selectedAirports" [latestActual]="latestAirport" [interval]="interval"
                                [params]="params" [lineCode]="selectedLine.code" [chartOptions]="chartOptions"
                                (dataEvent)="updateCompData($event)">
                </app-comparison>
                <app-comparison *ngIf="selectedLine.code=='7'" #comp7
                                [airports]="selectedAirports" [latestActual]="latestAirport" [interval]="interval"
                                [params]="params" [lineCode]="selectedLine.code" [chartOptions]="chartOptions"
                                (dataEvent)="updateCompData($event)">
                </app-comparison>
                <app-comparison *ngIf="selectedLine.code=='30'"  #comp30
                                [airports]="selectedAirports" [latestActual]="latestAirport" [interval]="interval"
                                [params]="params" [lineCode]="selectedLine.code" [chartOptions]="chartOptions"
                                (dataEvent)="updateCompData($event)">
                </app-comparison>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
  <div *ngIf="startDateStr > latestActual && tabIndex == 4 && selectedChart.code!='map'" style="margin-left:20px; color: tomato;">
    No data is available. Please select a period before {{latestActual}}.</div>
  <div *ngIf="startDateStr <= latestActual && endDateStr > latestActual && tabIndex == 4 && selectedChart.code!='map'" style="margin-left:20px;">
    * Data is on and before {{latestActual}}.</div>
  <div *ngIf="endDateStr >= latestActual && tabIndex != 4" style="margin-left:20px;">
    * Data after {{latestActual}} are estimate or forecast.</div>

  <!-- Loading Spinner -->
<!--  <div *ngIf="loading" class="loading-modal">-->
<!--    <img class="progress-spinner" src="assets/loading.gif" alt="loading...">-->
<!--  </div>-->
  <img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">

  <!-- Data Table Dialog -->
  <p-dialog header="{{tableLabel}} Chart Data" position="right" [(visible)]="displayData" [style]="windowWidth"
            [resizable]="true">
    <ng-template pTemplate="header">
      <button pButton type="button" icon="pi pi-download"
              class="p-button-rounded p-button-text p-button-plain title-button"
              (click)="csvDownload()"></button>
    </ng-template>
    <div *ngIf="startDateStr <= latestActual && endDateStr > latestActual && tabIndex == 4 && selectedChart.code!='map'" style="margin-left:10px;">
      * Data is on and before {{latestActual}}.</div>
    <div *ngIf="endDateStr >= latestActual && tabIndex != 4" style="margin-bottom:10px;">
      * Data after {{latestActual}} are estimate or forecast.</div>
    <app-grid [items]="tableData" [cols]="tableCols" [width]="tableWidth" [name]="tableName"></app-grid>
  </p-dialog>
</div>
